import React, { useEffect, useState } from "react";

const SHOW_AFTER_PX = 300;

const BackToTopButton: React.FC = () => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const onScroll = () => setVisible(window.scrollY > SHOW_AFTER_PX);
        window.addEventListener("scroll", onScroll, { passive: true });
        return () => window.removeEventListener("scroll", onScroll);
    }, []);

    const scrollToTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

    return (
        <button
            onClick={scrollToTop}
            aria-label="Back to top"
            style={{
                position:       "fixed",
                bottom:         28,
                right:          28,
                zIndex:         9999,
                width:          44,
                height:         44,
                borderRadius:   "50%",
                border:         "none",
                background:     "#309255",
                color:          "#fff",
                display:        "flex",
                alignItems:     "center",
                justifyContent: "center",
                boxShadow:      "0 4px 14px rgba(48,146,85,0.35)",
                paddingRight: "5px", 
                cursor:         "pointer",
                // show/hide with CSS transition
                opacity:        visible ? 1 : 0,
                pointerEvents:  visible ? "auto" : "none",
                transform:      visible ? "translateY(0)" : "translateY(12px)",
                transition:     "opacity 0.25s ease, transform 0.25s ease",
            }}
        >
            {/* Inline SVG (not the icon font) so the landing page never downloads the 526KB IcoFont. */}
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <polyline points="18 15 12 9 6 15" />
            </svg>
        </button>
    );
};

export default BackToTopButton;
